import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
	fill?: string;
}

export const UnmergeIcon: React.FC<IProps> = ({ className }) => {
	return (
		<SvgIcon className={className} height={24} width={24}>
			<rect width='24' height='24' fill='none' />
			<rect x='-1289' y='-214' width='1732' height='908' fill='url(#pattern0)' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2.15876 22H13.8418C13.2438 20.192 11.0078 19 7.99976 19C4.99176 19 2.75676 20.192 2.15876 22V22ZM15.9998 24H-0.000244141V23C-0.000244141 19.467 3.28976 17 7.99976 17C12.7108 17 15.9998 19.467 15.9998 23V24Z'
				fill='#F89143'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.72176 13C9.37476 13.595 8.73776 14 7.99976 14C6.89676 14 5.99976 13.103 5.99976 12C5.99976 10.896 6.89676 10 7.99976 10C8.36576 10 8.70476 10.106 8.99976 10.278V8.142C8.67876 8.059 8.34776 8 7.99976 8C5.79476 8 3.99976 9.794 3.99976 12C3.99976 14.206 5.79476 16 7.99976 16C9.85876 16 11.4108 14.72 11.8578 13H9.72176Z'
				fill='#F89143'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M18 0C14.691 0 12 2.691 12 6H14C14 3.794 15.794 2 18 2C20.206 2 22 3.794 22 6C22 8.206 20.206 10 18 10C16.931 10 15.926 9.584 15.22 8.881L15.173 8.827L17 7H12V12L13.757 10.243C14.889 11.376 16.396 12 18 12C21.309 12 24 9.309 24 6C24 2.691 21.309 0 18 0'
				fill='#F89143'
			/>
			<defs>
				<pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1' />
			</defs>
		</SvgIcon>
	);
};
